import $ from 'jquery';


export default () => {
    $('.newsletter-popup__open').on('click', function () {
        $('.newsletter-popup__open').addClass('hidden');
        $('.newsletter-popup__popup').addClass('active');
        $('.newsletter-popup__popup--content').addClass('active');
        $('.newsletter-popup__popup--close').addClass('active');
    });
    $('.newsletter-popup__popup--close').on('click', function () {
        $(this).removeClass('active');
        $('.newsletter-popup__popup').removeClass('active');
        $('.newsletter-popup__popup--content').removeClass('active');
        setTimeout(function () {
            $('.newsletter-popup__open').removeClass('hidden');
        }, 300);
    });
};



// WEBPACK FOOTER //
// ./scripts/libs/newsletter-popup.js